import { NdcList, NdcListFromJSON } from '@/api'
import * as runtime from '../runtime'

export class NdcListApi extends runtime.BaseAPI {
  /**
   * NDC検索リストを取得する
   * NDC検索リスト取得
   */
  async getNdcList(): Promise<NdcList[]> {
    const response = await this.requestGet('/ndc-list')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NdcListFromJSON)
    ).value()
  }
}
